import { render, staticRenderFns } from "./AccordionLayout.vue?vue&type=template&id=1194d982&"
import script from "./AccordionLayout.vue?vue&type=script&lang=js&"
export * from "./AccordionLayout.vue?vue&type=script&lang=js&"
import style0 from "./AccordionLayout.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports